// 常见问题
<template>
  <div class="cjwt width1200" role="tablist">
<!--    <div class="item">
      <p class="title">动态HTTP代理隧道常见问题</p>
      <div class="item-list">
        <div class="collapse-ans">
          本页面提供关于动态HTTP代理隧道的一些常见问题的解答，如果您在使用过程中遇到问题，可以参阅。此外，您也可以在相关技术支持群里寻求帮助。
        </div>
      </div>
    </div>-->
    <div class="item" v-for="(item, index) in cjwtList" :key="index">
      <p class="title">{{ item.title }}</p>
      <div class="item-list">
        <div
          v-for="(accordion, accordionIndex) in item.data"
          :key="accordionIndex"
        >
          <div
            class="collapse-title d-flex d-flex-aic d-flex-jc-sb"
            :class="tabs == `${index}-${accordionIndex}` ? 'active' : ''"
            @click="collapseChange(index, accordionIndex)"
          >
            <span>{{ accordion.req }}</span>
            <img
              :src="
                require(tabs == `${index}-${accordionIndex}`
                  ? '@/assets/images/icon12.png'
                  : '@/assets/images/icon11.png')
              "
              alt=""
            />
          </div>
          <div
            class="collapse-ans"
            :style="{
              display: tabs == `${index}-${accordionIndex}` ? 'block' : 'none',
            }"
          >
            {{ accordion.ans }}
            <!--{{ (tabs, `${index}-${accordionIndex}`) }}-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabs: "0-0",
      cjwtList: [
        {
          title: "功能相关问题",
          data: [
            {
              req: "1.白名单添加后代理无法访问",
              ans: "分布式中心同步数据需要等待几分钟",
            },
            {
              req: "2.实际代理出口IP和提取接口返回出口IP差异",
              ans: "边缘设备更新IP后中心数据更新延迟导致，不影响实际使用",
            },
            {
              req: "3.出现提取不满的情况",
              ans: "主要是中心下发配置过程中个别线路失败导致",
            },
            {
              req: "4.单个代理是否有并发限制",
              ans: "没有，但是实际使用会受到网络、边缘设备负载等外部因素影响没有一个具体的数值",
            },
          ],
        },
        // {
        //   title: "IP池相关问题",
        //   data: [
        //     {
        //       req: "池子里的代理IP都是在网上采集的免费代理吗？",
        //       ans: "1",
        //     },
        //     {
        //       req: "总池子多少IP？",
        //       ans: "1",
        //     },
        //     {
        //       req: "地区分布如何？",
        //       ans: "1",
        //     },
        //   ],
        // },
        // {
        //   title: "购买相关问题",
        //   data: [
        //     {
        //       req: "带宽或者每秒请求数能够在默认套餐基础上额外增加吗？",
        //       ans: "1",
        //     },
        //     {
        //       req: "可以免费测试吗？",
        //       ans: "2",
        //     },
        //     {
        //       req: "是否可以开具发票？",
        //       ans: "3",
        //     },
        //     {
        //       req: "是否可以签订合同？",
        //       ans: "4",
        //     },
        //   ],
        // },
      ],
    };
  },
  methods: {
    collapseChange(index, accordionIndex) {
      this.tabs = `${index}-${accordionIndex}`;
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/cjwt.less";
</style>
